(function() {
    'use strict';

    angular.module('app.grupos', []);
})();
